// extracted by mini-css-extract-plugin
export var displayDesktop = "TabsAndAccordionsConnector-module--displayDesktop--8c1d2";
export var displayMobile = "TabsAndAccordionsConnector-module--displayMobile--9069a";